import { deviceIsMobile, isSafari as isBrowserSafari } from "../../utils";
import { HelpModalItem } from "./HelpModalItem";
import { BlockedPermissionDescription } from "../BlockedPermissionDescription";

export function BlockedPermissionsActionItem({
  isMobile,
  isSafari,
}: {
  isMobile: boolean;
  isSafari: boolean;
}) {
  return (
    <HelpModalItem
      heading="My camera and microphone aren’t working"
      description={
        <div className="flex flex-col gap-4">
          <BlockedPermissionDescription
            isMobile={isMobile}
            isSafari={isSafari}
          />
        </div>
      }
    />
  );
}

export function BlockedPermissionsActionItemWrapper() {
  const isMobile = deviceIsMobile();
  const isSafari = isBrowserSafari();
  return (
    <BlockedPermissionsActionItem isMobile={isMobile} isSafari={isSafari} />
  );
}
